import React from 'react';
import { useIntl } from 'react-intl';
import { ArtistPortalStreamsByDimensionResponse } from 'fym-shared/src/smartlinks/artistPortals';
import { TypedMemo } from '../../../common/types';
import { formatDay } from '../streamingFormat';
import { streamingBlockMessages as messages } from '../streamingBlockMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole screen; each part uses its own slice of it */
import styles from '../Streaming.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface DimensionNoteProps {
  source: string;
  answer: ArtistPortalStreamsByDimensionResponse;
}

/** "As reported by Ditto for {start} – {end}. Change is against …" (design c1). */
const DimensionNoteComponent: React.FC<DimensionNoteProps> = ({ source, answer }) => {
  const intl = useIntl();
  const start = formatDay(intl, answer.range.from);
  const end = formatDay(intl, answer.range.to);
  const previous = answer.previousRange ?? null;
  return (
    <p className={styles.footnote}>
      {previous === null
        ? intl.formatMessage(messages.dimensionNoteNoPrevious, { source, start, end })
        : intl.formatMessage(messages.dimensionNote, {
            source,
            start,
            end,
            prevStart: formatDay(intl, previous.from),
            prevEnd: formatDay(intl, previous.to),
          })}
    </p>
  );
};

export const DimensionNote = TypedMemo(DimensionNoteComponent);
